<a #ref 
   attr.data-testid="{{testId}}-link"
   class="{{textCls}}" 
   (mouseenter)="mouseIn()" 
   (mouseleave)="mouseOut()">
    <ng-content></ng-content>
</a>